import React from 'react';
import { useParams } from 'react-router-dom';
import OAuthCallback from '../components/auth/OAuthCallback';

const OAuthCallbackPage: React.FC = () => {
  const { provider } = useParams<{ provider: string }>();

  if (!provider || !['linkedin', 'twitter'].includes(provider)) {
    return (
      <div className="page-container">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
          <div className="text-center">
            <h2>Invalid OAuth Provider</h2>
            <p>The OAuth provider "{provider}" is not supported.</p>
            <a href="/login" className="btn btn-primary">
              Return to Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  return <OAuthCallback provider={provider as 'linkedin' | 'twitter'} />;
};

export default OAuthCallbackPage;